exports.topMenu = '/api/sys/frontMenu/list' // 头部导航栏
exports.newList = '/api/yingxi/news/front/list' // 新闻列表
exports.queryNew = '/api/yingxi/news/front/queryById' // 新闻查询
exports.queryPage = '/api/yingxi/pageContent/front/queryByCode' // 页面内容查询
exports.queryTable = '/api/yingxi/publicTable/front/detailList' // 表格查询
exports.queryUsers = '/api/yingxi/person/front/list' // 董事会成员查询